import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import { AuthService } from '../../../core/service/auth.service';
import { DatesParserService} from '../../../core/service/dates_parser.service';
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Subscription} from "rxjs/Subscription";
import {FileDownloadService} from "../../../shared/components/file_download/file_download.service";

import Swal from 'sweetalert2';
import * as _ from 'underscore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import {RazonSocialService} from '../../../shared/service/razon-social.service';
import {ActivatedRoute} from '@angular/router';
import {FilesService} from '../files/files.service';
import {File} from '../files/model/file';

@Component({
  selector: 'app-files',
  templateUrl: './files-download.component.html'
})
export class FilesDownloadComponent implements OnInit {

    private campType: string;

    files: Array<File>;
    enabled: boolean;
    filePk: string = '';

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(private filesSrv: FilesService, private fileDownload: FileDownloadService, private activatedRoute: ActivatedRoute, private authService: AuthService) {
        this.files = [];
        this.enabled = false;

        this.fileDownload.getSubject().asObservable().subscribe(
            (msg) => {
                Swal('File download error', msg, 'error');
            }
        );

    }


    /**
     * inits component
     */
    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params: Object) => {
                this.enabled = true;
                this.filePk = params['id'];
                const query = { 'pk' : this.filePk };
                this.filesSrv.findFiles(query).subscribe(
                    data => {
                        this.files = data;
                        this.enabled = false;
                    }
                );
            }
        );
    }
};



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files-download/files-download.component.ts